import { cssVar } from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';
import { HEADER_HEIGHT } from '../HeaderBar';

const $border = cssVar('chakra-colors-borderBase');
export const getStyles = ({
  isMobileDevice,
  playerHeight,
}: {
  isMobileDevice: boolean;
  playerHeight: number;
}) => ({
  overlaySx: {
    position: 'relative',
    w: 'full',
    height: `cacl(var(--chakra-vh) - ${playerHeight})`,
    minHeight: '-webkit-fill-available',
    '.os-scrollbar': {
      '--os-handle-bg': $border.reference,
      '--os-handle-perpendicular-size': '8px',
      '--os-handle-perpendicular-size-hover': '8px',
      '--os-handle-perpendicular-size-active': '8px',
    },
    '.os-scrollbar-handle': {
      bg: 'transparent',
      w: '6px',
      rounded: 6,
    },
    _hover: {
      '.os-scrollbar-handle': {
        w: '6px',
        bg: transparentize('M.60', 0.18),
        _hover: {
          bg: transparentize('M.60', 0.54),
        },
        _focus: {
          bg: transparentize('M.60', 0.72),
        },
      },
    },
    ...(isMobileDevice && {
      '& .os-content-glue': {
        height: 'var(--chakra-vh)',
      },
    }),
    roundedTop: 6,
  },
  cardSx: {
    flexDirection: 'column',
    height: 'auto',
    w: 'full',
    position: 'relative',
    flex: 1,
    flexBasis: `calc(100vh - ${HEADER_HEIGHT}px - ${playerHeight}px)`,
  },
});
